import { useTranslation } from 'react-i18next'

export const Nosotros = () => {

  const { t } = useTranslation()
  const video = '/video/AZPITIA.mp4'

  return (
    <div className='main-content-display'>

      <div className='hero-container hero-dark'>
        <video autoPlay loop muted playsInline>
          <source src={video} type="video/mp4"></source>
        </video>
        <div className='hero-title'>
          <h1>{t("nosotros_hero")}</h1>
        </div>
      </div>

      <div className='container pt-5 pb-5'>

        <h3 className='text-center'>{t("nosotros_cabecera1")}</h3>
        <p className='text-center' style={{ fontSize: "1.8rem", lineHeight: "1.1" }}>
          {t("nosotros_texto1")}
        </p>

        <div className='pt-5 pb-5' >
          <div className='flex-panel'>
            <div>
              <img src='/image/nosotros/NS0001.webp' className='w-100' alt="NosotrosImg" />
            </div>
            <div className='p-5'>
              <h2>{t("nosotros_cabecera2")}</h2>
              <h5>{t("nosotros_sub_cabecera2")}</h5>
              <p className='text-justify line-height-sm'>
                {t("nosotros_texto2_p1")}
              </p>
              <p className='text-justify line-height-sm'>
                {t("nosotros_texto2_p2")}
              </p>
            </div>
          </div>
        </div>

        <div className='pt-5'>
          <div className='flex-panel' style={{ "--custom-direction": "column-reverse" }}>
            <div className='p-5'>
              <h2>{t("nosotros_cabecera3")}</h2>
              <h5>{t("nosotros_sub_cabecera3")}</h5>
              <p className='text-justify line-height-sm'>
                {t("nosotros_texto3_p1")}
              </p>
              <p className='text-justify line-height-sm'>
                {t("nosotros_texto3_p2")}
              </p>
            </div>
            <div className='d-flex'>
              <img src='/image/nosotros/NS0002.webp' className='w-100' alt="NosotrosImg" />
            </div>
          </div>
        </div>

        <div className='pt-5'>
          <div className='flex-panel'>
            <div className='d-flex'>
              <img src='/image/nosotros/NS0003.webp' className='w-100' alt="NosotrosImg" />
            </div>
            <div className='p-5'>
              <h2>{t("nosotros_cabecera4")}</h2>
              <h5>{t("nosotros_sub_cabecera4")}</h5>
              <p className='text-justify line-height-sm'>
                {t("nosotros_texto4")}
              </p>
            </div>
          </div>
        </div>
      </div>



      {/* <div className="container h-100">
        <div className="row align-items-center mt-4">
          <div className="col-12 col-lg-5">
            <h2>{t("nosotros_cabecera1")}</h2>
            <p style={{ textAlign: 'justify' }}>{t("nosotros_texto1")}</p>
            <h2>{t("nosotros_cabecera2")}</h2>
            <p style={{ textAlign: 'justify' }}>{t("nosotros_texto2")}</p>
            <h2>{t("nosotros_cabecera3")}</h2>
            <p style={{ textAlign: 'justify' }}>{t("nosotros_texto3")}</p>
          </div>
          <div className="col-12 col-lg-7 mb-2">
            <GaleriaImagenes imagenes={imagenesSeccionNosotros} />
          </div>
        </div>
      </div> */}

    </div>
  )
}
